import { Chip, Box, Typography } from "@mui/material";
import { Shirt } from "../../entities/Shirt";
import { EXTRA_DATA } from "../../types/types";

interface PropertyChipsProps {
  shirt: Shirt;
}

const PropertyChips = ({ shirt }: PropertyChipsProps) => {
  let chipArray = [];

  const excludedProperties = [
    EXTRA_DATA.CUSTOM_NUMBER,
    EXTRA_DATA.CUSTOM_TEXT,
    EXTRA_DATA.SIZE,
  ];

  const chipStyle = {
    fontWeight: "700 !important",
    color: "white !important",
    textTransform: "capitalize",
    fontSize: "0.9rem !important",
    fontStyle: "italic",
  };

  shirt.properties?.forEach((element: any) => {
    if (!excludedProperties.includes(element.key)) {
      chipArray.push(
        <Chip
          label={<Typography sx={chipStyle}>{element.key}</Typography>}
          sx={{ backgroundColor: "#3c3c40", paddingX: "5px" }}
        />
      );
    }
  });

  if (shirt.signature) {
    chipArray.push(
      <Chip
        label={<Typography sx={chipStyle}>{"Signed"}</Typography>}
        sx={{ backgroundColor: "#3c3c40", paddingX: "5px" }}
      />
    );
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", rowGap: 1, columnGap: 0.5 }}>
      {chipArray}
    </Box>
  );
};

export default PropertyChips;
